
// import { Link } from "react-router-dom";
// import "./../styles/header.css";
// import { useContext, useState } from "react";
// import { AuthContext } from "../context/AuthContext";

// export default function Header() {
//   const { token, user, logout } = useContext(AuthContext);
//   const [open, setOpen] = useState(false);

//   return (
//     <header className="header">
//       <h2>My Notes App</h2>

//       <nav>
//         <Link to="/">Home</Link>
//         {token && <Link to="/notes">Notes</Link>}
//         {token && <Link to="/add-note">Add Note</Link>}

//         {!token && <Link to="/login">Login</Link>}
//         {!token && <Link to="/register">Register</Link>}

//         {token && (
//           <div className="profile-menu">
//             <button className="profile-btn" onClick={() => setOpen(!open)}>
//               Profile ⬇
//             </button>

//             {open && (
//               <div className="dropdown">
//                 <p><strong>Name:</strong> {user?.username}</p>
//                 <p><strong>Email:</strong> {user?.email}</p>
//                 <button className="logoutBtn" onClick={logout}>Logout</button>
//               </div>
//             )}
//           </div>
//         )}
//       </nav>
//     </header>
//   );
// }




// import { Link } from "react-router-dom";
// import { useContext, useState } from "react";
// import { AuthContext } from "../context/AuthContext";
// import { useNavigate } from "react-router-dom";
// import {
//   AppBar,
//   Toolbar,
//   Typography,
//   Button,
//   Menu,
//   MenuItem,
//   Box,
//   IconButton,
//   useMediaQuery,
//   useTheme,
//   Avatar,
//   Divider,
//   ListItemIcon,
//   ListItemText
// } from "@mui/material";
// import {
//   Menu as MenuIcon,
//   Home as HomeIcon,
//   Notes as NotesIcon,
//   Add as AddIcon,
//   Login as LoginIcon,
//   PersonAdd as PersonAddIcon,
//   AccountCircle,
//   Logout
// } from "@mui/icons-material";

// export default function Header() {
//   const { token, user, logout } = useContext(AuthContext);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const navigate = useNavigate();



//   const handleMenuOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleLogout = () => {
//     logout();
//     handleMenuClose();
//     navigate("/");
//   };

//   return (
//     <AppBar 
//       position="static" 
//       elevation={2}
//       sx={{ 
//         backgroundColor: 'primary.main',
//         background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
//       }}
//     >
//       <Toolbar>
//         {/* Logo/Brand */}
//         <Typography
//           variant="h5"
//           component={Link}
//           to="/"
//           sx={{
//             flexGrow: { xs: 1, md: 0 },
//             fontWeight: "bold",
//             color: "white",
//             textDecoration: "none",
//             mr: 4,
//             background: 'linear-gradient(45deg, #fff 30%, #f0f0f0 90%)',
//             backgroundClip: 'text',
//             WebkitBackgroundClip: 'text',
//             color: 'transparent',
//           }}
//         >
//           📝 My Notes App
//         </Typography>

//         {/* Navigation Links - Desktop */}
//         {!isMobile && (
//           <Box sx={{ display: "flex", gap: 1, flexGrow: 1 }}>
//             <Button
//               component={Link}
//               to="/"
//               startIcon={<HomeIcon />}
//               sx={{ color: "white", fontWeight: 500 }}
//             >
//               Home
//             </Button>
//             {token && (
//               <>
//                 <Button
//                   component={Link}
//                   to="/notes"
//                   startIcon={<NotesIcon />}
//                   sx={{ color: "white", fontWeight: 500 }}
//                 >
//                   Notes
//                 </Button>
//                 <Button
//                   component={Link}
//                   to="/add-note"
//                   startIcon={<AddIcon />}
//                   sx={{ color: "white", fontWeight: 500 }}
//                 >
//                   Add Note
//                 </Button>
//               </>
//             )}
//           </Box>
//         )}

//         {/* Auth Section */}
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//           {!token ? (
//             <>
//               {!isMobile ? (
//                 <>
//                   <Button
//                     component={Link}
//                     to="/login"
//                     startIcon={<LoginIcon />}
//                     variant="outlined"
//                     sx={{ 
//                       color: "white", 
//                       borderColor: "white",
//                       '&:hover': {
//                         borderColor: 'white',
//                         backgroundColor: 'rgba(255,255,255,0.1)'
//                       }
//                     }}
//                   >
//                     Login
//                   </Button>
//                   <Button
//                     component={Link}
//                     to="/register"
//                     startIcon={<PersonAddIcon />}
//                     variant="contained"
//                     sx={{ 
//                       backgroundColor: "white",
//                       color: "primary.main",
//                       fontWeight: "bold",
//                       '&:hover': {
//                         backgroundColor: '#f5f5f5'
//                       }
//                     }}
//                   >
//                     Register
//                   </Button>
//                 </>
//               ) : (
//                 <IconButton
//                   component={Link}
//                   to="/login"
//                   sx={{ color: "white" }}
//                 >
//                   <LoginIcon />
//                 </IconButton>
//               )}
//             </>
//           ) : (
//             <>
//               {/* Profile Menu */}
//               <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                 {!isMobile && (
//                   <Typography 
//                     variant="body2" 
//                     sx={{ color: "white", fontWeight: 500 }}
//                   >
//                     Hello, {user?.username}
//                   </Typography>
//                 )}
//                 <IconButton
//                   onClick={handleMenuOpen}
//                   sx={{
//                     color: "white",
//                     backgroundColor: "rgba(255,255,255,0.1)",
//                     "&:hover": {
//                       backgroundColor: "rgba(255,255,255,0.2)",
//                     },
//                   }}
//                 >
//                   <AccountCircle />
//                 </IconButton>
//               </Box>

//               {/* Profile Dropdown Menu */}
//               <Menu
//                 anchorEl={anchorEl}
//                 open={Boolean(anchorEl)}
//                 onClose={handleMenuClose}
//                 PaperProps={{
//                   elevation: 3,
//                   sx: {
//                     mt: 1.5,
//                     minWidth: 200,
//                     borderRadius: 2,
//                     overflow: "visible",
//                     "&:before": {
//                       content: '""',
//                       display: "block",
//                       position: "absolute",
//                       top: 0,
//                       right: 14,
//                       width: 10,
//                       height: 10,
//                       bgcolor: "background.paper",
//                       transform: "translateY(-50%) rotate(45deg)",
//                       zIndex: 0,
//                     },
//                   },
//                 }}
//                 transformOrigin={{ horizontal: "right", vertical: "top" }}
//                 anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
//               >
//                 <MenuItem sx={{ pointerEvents: "none" }}>
//                   <ListItemIcon>
//                     <Avatar sx={{ width: 32, height: 32, bgcolor: "primary.main" }}>
//                       {user?.username?.charAt(0)?.toUpperCase()}
//                     </Avatar>
//                   </ListItemIcon>
//                   <Box>
//                     <Typography variant="subtitle1" fontWeight="bold">
//                       {user?.username}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {user?.email}
//                     </Typography>
//                   </Box>
//                 </MenuItem>
//                 <Divider />
//                 <MenuItem onClick={handleLogout}>
//                   <ListItemIcon>
//                     <Logout fontSize="small" />
//                   </ListItemIcon>
//                   <ListItemText>Logout</ListItemText>
//                 </MenuItem>
//               </Menu>
//             </>
//           )}

//           {/* Mobile Menu Button */}
//           {isMobile && token && (
//             <IconButton
//               sx={{ color: "white" }}
//               onClick={handleMenuOpen}
//             >
//               <MenuIcon />
//             </IconButton>
//           )}
//         </Box>
//       </Toolbar>
//     </AppBar>
//   );
// }

// import { Link } from "react-router-dom";
// import { useContext, useState } from "react";
// import { AuthContext } from "../context/AuthContext";
// import { useNavigate } from "react-router-dom";
// import {
//   AppBar,
//   Toolbar,
//   Typography,
//   Button,
//   Menu,
//   MenuItem,
//   Box,
//   IconButton,
//   useMediaQuery,
//   useTheme,
//   Avatar,
//   Divider,
//   ListItemIcon,
//   ListItemText
// } from "@mui/material";
// import {
//   Menu as MenuIcon,
//   Home as HomeIcon,
//   Notes as NotesIcon,
//   Add as AddIcon,
//   Login as LoginIcon,
//   PersonAdd as PersonAddIcon,
//   AccountCircle,
//   Logout
// } from "@mui/icons-material";

// export default function Header() {
//   const { token, user, logout } = useContext(AuthContext);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const navigate = useNavigate();

//   const handleMenuOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleLogout = () => {
//     logout();
//     handleMenuClose();
//     navigate("/");
//   };

//   return (
//     <AppBar
//       position="static"
//       elevation={2}
//       sx={{
//         backgroundColor: "primary.main",
//         background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
//       }}
//     >
//       <Toolbar>
//         {/* Logo/Brand */}
//         <Typography
//           variant="h5"
//           component={Link}
//           to="/"
//           sx={{
//             flexGrow: { xs: 1, md: 0 },
//             fontWeight: "bold",
//             textDecoration: "none",
//             mr: 4,
//             background: "linear-gradient(45deg, #fff 30%, #f0f0f0 90%)",
//             backgroundClip: "text",
//             WebkitBackgroundClip: "text",
//             color: "transparent"
//           }}
//         >
//           📝 My Notes App
//         </Typography>

//         {/* Desktop Links */}
//         {!isMobile && (
//           <Box sx={{ display: "flex", gap: 1, flexGrow: 1 }}>
//             <Button component={Link} to="/" startIcon={<HomeIcon />} sx={{ color: "white", fontWeight: 500 }}>
//               Home
//             </Button>
//             {token && (
//               <>
//                 <Button component={Link} to="/notes" startIcon={<NotesIcon />} sx={{ color: "white", fontWeight: 500 }}>
//                   Notes
//                 </Button>
//                 <Button component={Link} to="/add-note" startIcon={<AddIcon />} sx={{ color: "white", fontWeight: 500 }}>
//                   Add Note
//                 </Button>
//               </>
//             )}
//           </Box>
//         )}

//         {/* Auth/Profile Section */}
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//           {!token ? (
//             <>
//               {!isMobile ? (
//                 <>
//                   <Button component={Link} to="/login" startIcon={<LoginIcon />} variant="outlined"
//                     sx={{ color: "white", borderColor: "white", "&:hover": { borderColor: "white", backgroundColor: "rgba(255,255,255,0.1)" } }}>
//                     Login
//                   </Button>
//                   <Button component={Link} to="/register" startIcon={<PersonAddIcon />} variant="contained"
//                     sx={{ backgroundColor: "white", color: "primary.main", fontWeight: "bold", "&:hover": { backgroundColor: "#f5f5f5" } }}>
//                     Register
//                   </Button>
//                 </>
//               ) : (
//                 <IconButton component={Link} to="/login" sx={{ color: "white" }}>
//                   <LoginIcon />
//                 </IconButton>
//               )}
//             </>
//           ) : (
//             <>
//               {/* Desktop Profile */}
//               {!isMobile && (
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                   <Typography variant="body2" sx={{ color: "white", fontWeight: 500 }}>
//                     Hello, {user?.username}
//                   </Typography>
//                   <IconButton onClick={handleMenuOpen} sx={{ color: "white", backgroundColor: "rgba(255,255,255,0.1)", "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" } }}>
//                     <AccountCircle />
//                   </IconButton>
//                 </Box>
//               )}

//               {/* Mobile Menu Button */}
//               {isMobile && (
//                 <IconButton sx={{ color: "white" }} onClick={handleMenuOpen}>
//                   <MenuIcon />
//                 </IconButton>
//               )}

//               {/* Dropdown Menu */}
//               <Menu
//                 anchorEl={anchorEl}
//                 open={Boolean(anchorEl)}
//                 onClose={handleMenuClose}
//                 PaperProps={{
//                   elevation: 3,
//                   sx: {
//                     mt: 1.5,
//                     minWidth: 200,
//                     borderRadius: 2,
//                     overflow: "visible",
//                     "&:before": {
//                       content: '""',
//                       display: "block",
//                       position: "absolute",
//                       top: 0,
//                       right: 14,
//                       width: 10,
//                       height: 10,
//                       bgcolor: "background.paper",
//                       transform: "translateY(-50%) rotate(45deg)",
//                       zIndex: 0
//                     }
//                   }
//                 }}
//                 transformOrigin={{ horizontal: "right", vertical: "top" }}
//                 anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
//               >
//                 {/* Mobile Links */}
//                 {isMobile && (
//                   <>
//                     <MenuItem component={Link} to="/" onClick={handleMenuClose}>
//                       <HomeIcon sx={{ mr: 1 }} /> Home
//                     </MenuItem>
//                     <Divider />
//                     <MenuItem component={Link} to="/notes" onClick={handleMenuClose}>
//                       <NotesIcon sx={{ mr: 1 }} /> Notes
//                     </MenuItem>
//                     <MenuItem component={Link} to="/add-note" onClick={handleMenuClose}>
//                       <AddIcon sx={{ mr: 1 }} /> Add Note
//                     </MenuItem>
//                     <Divider />
//                   </>
//                 )}

//                 {/* Profile Info */}
//                 <MenuItem sx={{ pointerEvents: "none" }}>
//                   <ListItemIcon>
//                     <Avatar sx={{ width: 32, height: 32, bgcolor: "primary.main" }}>
//                       {user?.username?.charAt(0)?.toUpperCase()}
//                     </Avatar>
//                   </ListItemIcon>
//                   <Box>
//                     <Typography variant="subtitle1" fontWeight="bold">
//                       {user?.username}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {user?.email}
//                     </Typography>
//                   </Box>
//                 </MenuItem>

//                 <Divider />
//                 <MenuItem onClick={handleLogout}>
//                   <ListItemIcon>
//                     <Logout fontSize="small" />
//                   </ListItemIcon>
//                   <ListItemText>Logout</ListItemText>
//                 </MenuItem>
//               </Menu>
//             </>
//           )}
//         </Box>
//       </Toolbar>
//     </AppBar>
//   );
// }







import { Link } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Menu,
  MenuItem,
  Box,
  IconButton,
  useMediaQuery,
  useTheme,
  Avatar,
  Divider,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import {
  Menu as MenuIcon,
  Home as HomeIcon,
  Notes as NotesIcon,
  Add as AddIcon,
  Login as LoginIcon,
  PersonAdd as PersonAddIcon,
  AccountCircle,
  Logout
} from "@mui/icons-material";

export default function Header() {
  const { token, user, logout } = useContext(AuthContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleMenuClose();
    navigate("/");
  };

  return (
    <AppBar
      position="static"
      elevation={2}
      sx={{
        backgroundColor: "primary.main",
        background: "linear-gradient(135deg, #2e0d35ff 0%, #764ba2 100%)"
      }}
    >
      <Toolbar>
        {/* Logo/Brand */}
        <Typography
          variant="h5"
          component={Link}
          to="/"
          sx={{
            flexGrow: { xs: 1, md: 0 },
            fontWeight: "bold",
            textDecoration: "none",
            mr: 4,
            background: "linear-gradient(45deg, #fff 30%, #f0f0f0 90%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent"
          }}
        >
          📝 MyKe Notes 
        </Typography>

        {/* Desktop Links */}
        {!isMobile && (
          <Box sx={{ display: "flex", gap: 1, flexGrow: 1 }}>
            <Button component={Link} to="/" startIcon={<HomeIcon />} sx={{ color: "white", fontWeight: 500 }}>
              Home
            </Button>
            {token && (
              <>
                <Button component={Link} to="/notes" startIcon={<NotesIcon />} sx={{ color: "white", fontWeight: 500 }}>
                  Notes
                </Button>
                <Button component={Link} to="/add-note" startIcon={<AddIcon />} sx={{ color: "white", fontWeight: 500 }}>
                  Add Note
                </Button>
              </>
            )}
          </Box>
        )}

        {/* Auth/Profile Section */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {!token ? (
            <>
              {!isMobile ? (
                <>
                  <Button component={Link} to="/login" startIcon={<LoginIcon />} variant="outlined"
                    sx={{ color: "white", borderColor: "white", "&:hover": { borderColor: "white", backgroundColor: "rgba(255,255,255,0.1)" } }}>
                    Login
                  </Button>
                  <Button component={Link} to="/register" startIcon={<PersonAddIcon />} variant="contained"
                    sx={{ backgroundColor: "white", color: "primary.main", fontWeight: "bold", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                    Register
                  </Button>
                </>
              ) : (
                <IconButton sx={{ color: "white" }} onClick={handleMenuOpen}>
                  <MenuIcon />
                </IconButton>
              )}
            </>
          ) : (
            <>
              {/* Desktop Profile */}
              {!isMobile && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="body2" sx={{ color: "white", fontWeight: 500 }}>
                    Hello, {user?.username}
                  </Typography>
                  <IconButton onClick={handleMenuOpen} sx={{ color: "white", backgroundColor: "rgba(255,255,255,0.1)", "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" } }}>
                    <AccountCircle />
                  </IconButton>
                </Box>
              )}

              {/* Mobile Menu Button */}
              {isMobile && (
                <IconButton sx={{ color: "white" }} onClick={handleMenuOpen}>
                  <MenuIcon />
                </IconButton>
              )}
            </>
          )}
        </Box>

        {/* Dropdown Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          PaperProps={{
            elevation: 3,
            sx: {
              mt: 1.5,
              minWidth: 200,
              borderRadius: 2,
              overflow: "visible",
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0
              }
            }
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          {isMobile && !token && (
            <>
              <MenuItem component={Link} to="/login" onClick={handleMenuClose}>
                <LoginIcon sx={{ mr: 1 }} /> Login
              </MenuItem>
              <MenuItem component={Link} to="/register" onClick={handleMenuClose}>
                <PersonAddIcon sx={{ mr: 1 }} /> Register
              </MenuItem>
              <Divider />
            </>
          )}

          {/* Mobile Links for logged-in user */}
          {isMobile && token && (
            <>
              <MenuItem component={Link} to="/" onClick={handleMenuClose}>
                <HomeIcon sx={{ mr: 1 }} /> Home
              </MenuItem>
              <MenuItem component={Link} to="/notes" onClick={handleMenuClose}>
                <NotesIcon sx={{ mr: 1 }} /> Notes
              </MenuItem>
              <MenuItem component={Link} to="/add-note" onClick={handleMenuClose}>
                <AddIcon sx={{ mr: 1 }} /> Add Note
              </MenuItem>
              <Divider />
            </>
          )}

          {/* Profile Info */}
          {token && (
            <>
              <MenuItem sx={{ pointerEvents: "none" }}>
                <ListItemIcon>
                  <Avatar sx={{ width: 32, height: 32, bgcolor: "primary.main" }}>
                    {user?.username?.charAt(0)?.toUpperCase()}
                  </Avatar>
                </ListItemIcon>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {user?.username}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {user?.email}
                  </Typography>
                </Box>
              </MenuItem>
              <Divider />
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                <ListItemText>Logout</ListItemText>
              </MenuItem>
            </>
          )}
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
